import React from 'react';
import { BORDER_RADIUS } from '../constants/layout';
import { getDisplayUnitAmount } from '../utils/priceFormatter';

export const SORT_OPTIONS = [
  { value: 'name_asc',   label: 'Name: A → Z' },
  { value: 'name_desc',  label: 'Name: Z → A' },
  { value: 'price_asc',  label: 'Price: Low to High' },
  { value: 'price_desc', label: 'Price: High to Low' },
];

function getPrice(p) {
  return getDisplayUnitAmount(p?.priceInfo);
}

export function sortProducts(products, sortBy) {
  return [...products].sort((a, b) => {
    switch (sortBy) {
      case 'name_desc':
        return (b.productName || '').toLowerCase().localeCompare((a.productName || '').toLowerCase());
      case 'price_asc': {
        const pa = getPrice(a), pb = getPrice(b);
        if (pa == null && pb == null) return 0;
        if (pa == null) return 1;
        if (pb == null) return -1;
        return pa - pb;
      }
      case 'price_desc': {
        const pa = getPrice(a), pb = getPrice(b);
        if (pa == null && pb == null) return 0;
        if (pa == null) return 1;
        if (pb == null) return -1;
        return pb - pa;
      }
      default: // name_asc
        return (a.productName || '').toLowerCase().localeCompare((b.productName || '').toLowerCase());
    }
  });
}

export default function SortPicker({ value, onChange }) {
  return (
    <select
      value={value}
      onChange={e => onChange(e.target.value)}
      style={{
        padding: '4px 10px',
        borderRadius: BORDER_RADIUS,
        border: '1px solid var(--color-border)',
        backgroundColor: 'var(--color-surface-muted)',
        color: 'var(--color-text-primary)',
        fontSize: '0.875rem',
        cursor: 'pointer',
        outline: 'none',
      }}
    >
      {SORT_OPTIONS.map(opt => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  );
}
